import React, { useState } from "react";
import { Grid2 as Grid, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { AddCircleOutline, ExpandMore } from '@mui/icons-material';
import { CustomControlledInput } from "./CustomControlledInput";
import { BoxSpaceCenter } from "../style/box";
import { RegisterButton } from "../style/button";
import { TypographyBold } from '../style/typography';

const UserRegistration = ({ control, departmentList, roleList, openDialog, handleRegistSubmit, expanded = false, isDisabled }) => {
    const [isExpanded, setIsExpanded] = useState(expanded);

    return (
        <Grid size={{ xs: 12 }}>
            <Accordion expanded={isExpanded} onChange={() => setIsExpanded(!isExpanded)}>
                <AccordionSummary
                    expandIcon={<ExpandMore />}
                    aria-controls="user-registration-content"
                    id="user-registration-header"
                >
                    <TypographyBold>新規ユーザー登録</TypographyBold>
                </AccordionSummary>
                <AccordionDetails>
                    <form
                        style={{ width: "100%" }}
                        onSubmit={handleRegistSubmit((data) => {
                            openDialog('register', data.registUser);
                        })}
                    >
                        <Grid container spacing={3}>
                            {/* 氏名 */}
                            <Grid size={{ xs: 12, md: 4 }}>
                                <CustomControlledInput
                                    name="registUser.name"
                                    control={control}
                                    label="氏名"
                                    variant="outlined"
                                    placeholder="山田太郎"
                                    inputProps={{ maxLength: 100 }}
                                    disabled={isDisabled}
                                />
                            </Grid>
                            {/* 電話番号 */}
                            <Grid size={{ xs: 12, md: 4 }}>
                                <CustomControlledInput
                                    name="registUser.tel"
                                    control={control}
                                    label="電話番号（ハイフン無し）"
                                    placeholder="09012345678"
                                    inputProps={{ maxLength: 11, pattern: '[0-9]*' }}
                                    onKeyPress={(e) => {
                                        if (!/[0-9]/.test(e.key)) e.preventDefault();
                                    }}
                                    disabled={isDisabled}
                                />
                            </Grid>
                            {/* メール */}
                            <Grid size={{ xs: 12, md: 4 }}>
                                <CustomControlledInput
                                    name="registUser.email"
                                    control={control}
                                    label="メールアドレス"
                                    variant="outlined"
                                    placeholder="example@kyuden.co.jp"
                                    inputProps={{ maxLength: 255 }}
                                    disabled={isDisabled}
                                />
                            </Grid>
                            {/* パスワード */}
                            <Grid size={{ xs: 12, md: 6 }}>
                                <CustomControlledInput
                                    name="registUser.password"
                                    control={control}
                                    label="パスワード"
                                    type="password"
                                    autoComplete="password"
                                    variant="outlined"
                                    placeholder="パスワードを入力"
                                    disabled={isDisabled}
                                />
                            </Grid>
                            {/* パスワード確認 */}
                            <Grid size={{ xs: 12, md: 6 }}>
                                <CustomControlledInput
                                    name="registUser.password_confirm"
                                    control={control}
                                    label="パスワード(確認)"
                                    type="password"
                                    autoComplete="password"
                                    variant="outlined"
                                    placeholder="パスワードを入力"
                                    disabled={isDisabled}
                                />
                            </Grid>
                            {/* 所属 */}
                            <Grid size={{ xs: 12, md: 6 }}>
                                <CustomControlledInput
                                    name="registUser.department"
                                    control={control}
                                    label="所属"
                                    type="select"
                                    multiple={false}
                                    options={departmentList.map((d) => ({
                                        value: d.uuid,
                                        label: d.name
                                    }))}
                                    disabled={isDisabled}
                                />
                            </Grid>
                            {/* 権限 */}
                            <Grid size={{ xs: 12, md: 6 }}>
                                <CustomControlledInput
                                    name="registUser.role"
                                    control={control}
                                    label="権限"
                                    type="select"
                                    multiple={false}
                                    options={roleList.map((r) => ({
                                        value: r.uuid,
                                        label: r.name
                                    }))}
                                    disabled={isDisabled}
                                />
                            </Grid>

                            {/* 登録ボタン */}
                            <Grid container size={{ xs: 12 }} justifyContent="center">
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <BoxSpaceCenter>
                                        <RegisterButton
                                            fullWidth
                                            type="submit"
                                            variant="contained"
                                            startIcon={<AddCircleOutline />}
                                            disabled={isDisabled}
                                        >
                                            ユーザーを登録
                                        </RegisterButton>
                                    </BoxSpaceCenter>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
};

export default UserRegistration;